import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { LaserBoxBlockComponent } from './LaserBoxBlockComponent';
import { LaserBoxBlockProps } from './LaserBoxBlock';

const LaserBoxBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  LaserBoxBlockComponent,
);
export type LaserBoxBlockEntity = EntityType<typeof LaserBoxBlockEntityDef>;

export function _spawnLaserBoxBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: LaserBoxBlockProps,
  position: Vector2,
): LaserBoxBlockEntity {
  const entity = _spawnBaseBlockEntity(
    LaserBoxBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockLaserBox: {
        props: props,
        option: def.option,
      },
    },
  );
  entity.c.view2d.view.addChild(entity.c.blockLaserBox.view);
  return entity;
}
